import React from 'react';

import './form-success.styles.scss';

const FormSuccess = () => {
    return (
        <h3>Email sent succesfully, thank you!</h3>
    )
}

export default FormSuccess;